import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Typography,
  Table,
  Modal,
  message,
  DatePickerProps,
  Flex,
  Tag,
  Switch,
  Popconfirm,
} from "antd";
import {
  DownloadOutlined,
  PlusCircleFilled,
  SearchOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { CSVLink } from "react-csv";
import dayjs, { Dayjs } from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { Layout } from "antd";
import { DataType } from "../redux/slices/VehicleAccountSlice";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import "../styles/App.css";
import {
  CreatePaidPayment,
  CreatePaymentRequest,
  fetchdata,
  SendPdf,
  updateTopay,
} from "src/redux/actions/vehicalaccountAction";
import CustomTableLoader from "src/components/common/CustomTableLoader";
import { BlockedDriver } from "src/redux/actions/DriverAttenAction";

const VehicleAccount: React.FC = (record: any) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const { Title } = Typography;
  const [toPayForm] = Form.useForm();
  const [paidForm] = Form.useForm();
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [toDate, setToDate] = useState<Dayjs | null>(null);
  const [selectedCabId, setSelectedCabId] = useState<string | null>(null);
  const [selectedBonupoint, setSelectedBonupoint] = useState<string | null>(
    null,
  );

  const [selectednewVehCharge, setSelectednewVehCharge] = useState<any | null>(
    null,
  );

  const [selectedCab, setSelectedCab] = useState<any>(null);
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
  const [isPaidModalVisible, setPaidModalVisible] = useState(false);
  const [searchText, setSearchText] = useState<string>("");
  const [activeFilter, setActiveFilter] = useState<any[]>([]);
  const [limit, setLimit] = useState<number>(10);
  const [skip, setSkip] = useState<number>(0);
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const branchid = userData.cityid;
  const vehicleAccountData = useSelector(
    (state: any) => state.vehicleAccount.data || {},
  );
  const toPayData = useSelector(
    (state: RootState) => state.vehicleAccount.toPayData,
  );
  const loading = useSelector(
    (state: RootState) => state.vehicleAccount.loading,
  );
  const update = useSelector((state: RootState) => state.vehicleAccount.create);
  const {
    data: cabList = [],
    TotalEarned = 0,
    tablelength = 0,
    TotalFare = 0,
    TotalTrips = 0,
    TotalDistance = 0,
    TotalBalance = 0,
    TotalPaidAmount = 0,
    TotalCreditFare = 0,
    TotalOverdue = 0,
    TotalPending = 0,
    TotalSurplus = 0,
  } = vehicleAccountData;

  useEffect(() => {
    if (toPayData) {
      toPayForm.setFieldsValue({
        topay: toPayData.toPay,
        Category: toPayData.bonusPoints,
        subAmount: toPayData.subAmount,
        adjustToPay: toPayData.adjustToPay,
        prevBal: toPayData.prevBal,
        creditFare: toPayData.prepaid,
      });
    }
  }, [toPayData, toPayForm]);

  const handleSend = (record: any) => {
    console.log("Send clicked for:", record);
    const defaultTuesday = getDefaultTuesday().subtract(1, "week");
    const defaultMonday = defaultTuesday.add(6, "day");
    const toDatePlusOne = defaultMonday.add(1, "day");

    const payload = {
      cabid: record.cab_id,
      toPayId: record.toPayId,
      toPay: record.toPay,
      daysActive: record.daysActive,
      rideCount: record.rideCount,
      Cancelled: record.Cancelled,
      earned: record.earned,
      toDate: toDatePlusOne.format("YYYY-MM-DD"),
    };
    dispatch(SendPdf(payload));
  };

  const columns: any = [
    {
      title: "CAB ID",
      dataIndex: "cab_id",
      key: "cab_id",
      align: "center",
      fixed: "left",
    },
    {
      title: "Amount",
      dataIndex: "totalFare",
      key: "totalFare",
      align: "center",
    },
    {
      title: "Trip",
      dataIndex: "rideCount",
      key: "rideCount",
      align: "center",
      width: 70,
    },
    {
      title: "Days",
      dataIndex: "daysActive",
      key: "daysActive",
      align: "center",
      width: 70,
    },
    {
      title: "Cancel",
      dataIndex: "Cancelled",
      key: "Cancelled",
      align: "center",
      width: 80,
    },
    {
      title: "Paid Status",
      dataIndex: "paidStatus",
      key: "paidStatus",
      align: "center",
      filters: [
        { text: "Paid", value: "Paid" },
        { text: "Unpaid", value: "Unpaid" },
        { text: "Pending", value: "Pending" },
        { text: "Overdue", value: "Overdue" },
        { text: "Surplus", value: "Surplus" },
        { text: "No Due", value: "No Due" },
      ],
      onFilter: (value: any, record: any) => record.paidStatus === value,
      render: (text: any) => {
        let color = "";

        switch (text) {
          case "Paid":
            color = "#3f730b";
            break;
          case "Unpaid":
            color = "#930c03";
            break;
          case "Pending":
            color = "rgb(191, 114, 80)";
            break;
          case "Overdue":
            color = "rgb(79 67 206)";
            break;
          case "Surplus":
            color = "rgb(47 137 148)";
            break;
          case "No Due":
            color = "#948600";
            break;
          default:
            color = "grey";
        }

        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: "Add To Pay",
      dataIndex: "toPayPercent",
      key: "toPayPercent",
      align: "center",
      width: 80,

      render: (text: any, record: DataType) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span style={{ fontSize: "15px" }}>{record.addPayments}</span>
          <Button
            style={{ fontSize: "15px" }}
            shape="circle"
            icon={<PlusCircleFilled />}
            onClick={() => {
              setSelectedCabId(record.cabId || record.cab_id);
              setSelectednewVehCharge(record.newVehCharge);
              setIsPaymentModalVisible(true);
              setSelectedCab(record);
              calculateDefaultValues(record);
            }}
          />
        </div>
      ),
    },
    {
      title: "To Pay",
      dataIndex: "toPay",
      key: "toPay",
      align: "center",
    },
    {
      title: "Add paid Amt",
      dataIndex: "toPayPercent",
      key: "toPayPercent",
      align: "center",
      width: 80,

      render: (text: any, record: DataType) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span style={{ fontSize: "15px" }}>{record.addPayments}</span>
          {/* <Button
            style={{ fontSize: "18px" }}
             icon={ */}
          <img
            src="/assets/plus1.svg"
            alt="icon"
            style={{ width: 20, height: 40 }}
            onClick={() => {
              setSelectedCabId(record.cabId || record.cab_id);
              const onlyNumber =
                record.toPayPercent?.toString().match(/\d+/)?.[0] || "0";
              setSelectedBonupoint(onlyNumber);
              setPaidModalVisible(true);
              setSelectedCab(record);
              calculateDefaultValuess(record);
            }}
            //   />
            // }
          />
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
       filters: [
        { text: "Active", value: "Active" },
        { text: "Inactive", value: "Inactive" },
      ],
      onFilter: (value: any, record: any) => record.isactive === value,
      render: (_: any, record: any) => (
        <Popconfirm
          title={`Are you sure you want to ${
            record.status === 1 ? "Inactive" : "Active"
          } this Cab?`}
          onConfirm={() => handleToggleStatus(record, record.status !== 1)}
          okText="Yes"
          cancelText="No"
          placement="top"
        >
          <Switch
            checked={record.status === 1}
            checkedChildren="Active"
            unCheckedChildren="Inactive"
          />
        </Popconfirm>
      ),
    },
    {
      title: "Driver Status",
      dataIndex: "driver_status",
      key: "driver_status",
      align: "center",
    },
    {
      title: "Paid Amount",
      dataIndex: "paidAmount",
      key: "paidAmount",
      align: "center",
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      align: "center",
      onCell: (record: any) => {
        const bal = record.balance;
        if (bal === 0) {
          return { style: {} };
        }
        return {
          style: {
            backgroundColor: bal < 0 ? "#ffcccc" : "#cce5ff",
            color: bal < 0 ? "red" : "blue",
          },
        };
      },
    },
    {
      title: "Prepaid",
      dataIndex: "creditFare",
      key: "creditFare",
      align: "center",
    },
    {
      title: "Prev Bal",
      dataIndex: "prevBal",
      key: "prevBal",
      align: "center",
    },
    {
      title: "Amount Change",
      dataIndex: "amountChange",
      key: "amountChange",
      align: "center",
    },
    {
      title: "Earned",
      dataIndex: "earned",
      key: "earned",
      align: "center",
    },
    {
      title: "Category",
      dataIndex: "toPayPercent",
      key: "toPayPercent",
      align: "center",
    },
    {
      title: "Inactive Reason",
      dataIndex: "blockReason",
      key: "blockReason",
      align: "center",
      width: 150,
    },
    // {
    //   title: "Send",
    //   key: "send",
    //   align: "center",
    //   width: 90,
    //   render: (_: any, record: any) => (
    //     <Button type="primary" style={{background:"#884399"}} size="small" onClick={() => handleSend(record)}>
    //      <SendOutlined />
    //     </Button>
    //   ),
    // },
    // {
    //   title: "Report Url",
    //   dataIndex: "reportUrl",
    //   key: "reportUrl",
    //    align: "center",
    //   width: 250,
    // },
  ];

  const filteredDataSource = cabList.filter((record: any) => {
    const cabId = (record.cab_id || "").toLowerCase();
    const search = searchText.toLowerCase();

    const matchesCabId = cabId.includes(search);
    const matchesStatus = record.isactive?.toLowerCase().includes(search);

    return matchesCabId || matchesStatus;
  });

  const finalFilteredData = filteredDataSource.filter((row: any) => {
    if (activeFilter.length > 0) {
      return activeFilter.includes(row.isactive);
    }
    return true;
  });

  const headers = [
    { label: "cab_id", key: "cab_id" },
    { label: "isactive", key: "isactive" },
    { label: "driver_status", key: "driver_status" },
    { label: "rideCount", key: "rideCount" },
    { label: "daysActive", key: "daysActive" },
    { label: "totalFare", key: "totalFare" },
    { label: "Cancelled", key: "Cancelled" },
    { label: "earned", key: "earned" },
    { label: "creditFare", key: "creditFare" },
    { label: "balance", key: "balance" },
    { label: "toPayPercent", key: "toPayPercent" },
    { label: "prevBal", key: "prevBal" },
    { label: "paidStatus", key: "paidStatus" },
    { label: "paidAmount", key: "paidAmount" },
    { label: "toPay", key: "toPay" },
  ];

  const csvData = finalFilteredData.map((row: any) => ({
    cab_id: row.cab_id,
    isactive: row.isactive,
    driver_status: row.driver_status,
    rideCount: row.rideCount,
    daysActive: row.daysActive,
    totalFare: row.totalFare,
    Cancelled: row.Cancelled,
    earned: row.earned,
    creditFare: row.creditFare,
    balance: row.balance,
    toPayPercent: row.toPayPercent,
    prevBal: row.prevBal,
    paidStatus: row.paidStatus,
    paidAmount: row.paidAmount,
    toPay: row.toPay,
  }));

  useEffect(() => {
    if (fromDate && toDate) {
      // const toDatePlusOne = defaultMonday.add(1, "day");
      const from = fromDate.format("YYYY-MM-DD");
      const toPlusOne = dayjs(toDate).add(1, "day").format("YYYY-MM-DD");
      if (update?.success) {
        dispatch(fetchdata(branchid, from, toPlusOne));
      }
    }
  }, [update.success]);

  useEffect(() => {
    // const defaultTuesday = getDefaultTuesday();
    const defaultTuesday = getDefaultTuesday().subtract(1, "week");
    const defaultMonday = defaultTuesday.add(6, "day");
    setFromDate(defaultTuesday);
    setToDate(defaultMonday);

    const toDatePlusOne = defaultMonday.add(1, "day");

    dispatch(
      fetchdata(
        branchid,
        defaultTuesday.format("YYYY-MM-DD"),
        toDatePlusOne.format("YYYY-MM-DD"),
      ),
    );
  }, []);

  useEffect(() => {
    if (update?.success) {
      setIsPaymentModalVisible(false);
      setPaidModalVisible(false);
      toPayForm.resetFields();
      paidForm.resetFields();
    }
  }, [update?.success]);

  const now = dayjs();
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);

  const handleTableChange = (pagination: any, filters: any) => {
    setActiveFilter(filters.isactive || []);
  };

  const disabledPrevWeeksOnly = (current: dayjs.Dayjs) => {
    if (!current) return true;

    const startOfCurrentCustomWeek = dayjs().startOf("week").add(2, "day");

    return current.isSameOrAfter(startOfCurrentCustomWeek, "day");
  };

  const getTuesday = (date: Dayjs) => {
    let tuesday = date.startOf("week").add(2, "day");
    if (date.day() < 2) {
      tuesday = tuesday.subtract(7, "day");
    }
    return tuesday;
  };

  const calculateDefaultValues = (record: any) => {
    if (record.totalFare !== undefined && record.totalFare !== null) {
      const amount = parseFloat(record.totalFare || 0);
      const rawPercent = parseFloat(record.toPayPercent);
      const categoryPercent = rawPercent > 0 ? rawPercent : 18;
      const creditFare = parseFloat(record.creditFare || 0);
      const prevBal = parseFloat(record.prevBal || 0);
      const subAmount = parseFloat(record.subAmount || 0);
      const adjustToPay = parseFloat(record.amountChange || 0);

      // let toPay = Math.round(
      //   (amount * categoryPercent) / 100 - creditFare + prevBal + subAmount
      // );
      // toPay = Math.round(toPay + adjustToPay);

      const toPay = record.toPay;
      const formatNumber = (num: any) =>
        Number.isInteger(num) ? num.toString() : num.toFixed(2);

      toPayForm.setFieldsValue({
        cabId: record.cabId || record.cab_id,
        amount: record.totalFare,
        Prepaid: record.prepaid,
        Category: categoryPercent,
        paid: record.paid,
        topay: formatNumber(toPay),
        status: record.status,
        creditFare: record.creditFare,
        prevBal: record.prevBal,
        paidAmount: record.paidAmount,
        subAmount: record.subAmount,
        adjustToPay: record.amountChange,
      });
    }
  };
  const calculateDefaultValuess = (record: any) => {
    if (record.totalFare !== undefined && record.totalFare !== null) {
      const paid = parseFloat(record.paid || 0);
      let toPay = 0;
      if (record.paidStatus === "Pending") {
        toPay = parseFloat(record.balance || 0);
      } else {
        toPay = parseFloat(record.toPay || 0);
      }
      const paidAmount = parseFloat(record.paidAmount || 0);

      const balance = record.balance || 0;
      // const paidAmount = parseFloat(record.paidAmount || 0);

      //  const balance = Math.round(toPay - paid - paidAmount);
      const formatNumber = (num: number) =>
        Number.isInteger(num) ? num.toString() : num.toFixed(2);

      paidForm.setFieldsValue({
        topay: formatNumber(toPay),
        Balance: formatNumber(balance),
        paidAmount: formatNumber(paidAmount),
      });
    }
  };

  const handleFetch = () => {
    if (fromDate && toDate) {
      const from = fromDate.format("YYYY-MM-DD");
      const toPlusOne = dayjs(toDate).add(1, "day").format("YYYY-MM-DD");

      dispatch(fetchdata(branchid, from, toPlusOne));
    } else {
      message.warning("Please select both From and To dates.");
    }
  };

  const getDefaultTuesday = () => {
    const today = dayjs();
    const dayOfWeek = today.day();
    if (dayOfWeek >= 2) {
      return today.startOf("week").add(2, "day");
    } else {
      return today.startOf("week").subtract(5, "day");
    }
  };

  const weekFormat = "MM/DD";
  const customWeekStartEndFormat: DatePickerProps["format"] = (value) =>
    `${dayjs(value).startOf("week").format(weekFormat)} ~ ${dayjs(value)
      .endOf("week")
      .format(weekFormat)}`;

  const handleToggleStatus = (record: any, checked: boolean) => {
    const defaultTuesday = getDefaultTuesday().subtract(1, "week");
    const defaultMonday = defaultTuesday.add(6, "day");
    const toDatePlusOne = defaultMonday.add(1, "day");
    const updatedStatus = checked ? 1 : 0;
    const payload = {
      cabid: record.cab_id,
      userName: userData.employeename,
      status: updatedStatus,
    };
    dispatch(BlockedDriver(payload));
    dispatch(
      fetchdata(
        branchid,
        defaultTuesday.format("YYYY-MM-DD"),
        toDatePlusOne.format("YYYY-MM-DD"),
      ),
    );
    dispatch(
      fetchdata(
        branchid,
        defaultTuesday.format("YYYY-MM-DD"),
        toDatePlusOne.format("YYYY-MM-DD"),
      ),
    );
  };

  const handleTopayFormSubmit = (values: any, status: string = "Paid") => {
    const payload = {
      cabId: selectedCabId,
      amount: String(values.amount),
      updatedBy: userData.employeename,
      bonusPoints: Number(values.Category),
      prepaid: values.creditFare,
      fromDate: fromDate,
      toDate: toDate,
      toPay: values.topay,
      prevBal: values.prevBal,
      subAmount: values.subAmount,
      adjustToPay: values.adjustToPay,
    };

    dispatch(CreatePaymentRequest(payload));
  };

  const handlePaidFormSubmit = (values: any, record: any) => {
    const payload = {
      toPay: values.topay,
      cabId: selectedCabId,
      bonusPoints: selectedBonupoint?.match(/\d+/)?.[0] || "0",
      paidAmount: String(values.paid),
      balance: String(values.Balance),
      paymentDelay: values.paymentDelay,
      updatedBy: userData.employeename,
      referNo: values.referenceNo,
      fromDate: fromDate,
      toDate: toDate,
      paymentMode: values.paymentMode,
      amntRecDate: values.amntRecDate
        ? values.amntRecDate.format("YYYY-MM-DD")
        : null,
      remark: values.remark || "",
    };

    dispatch(CreatePaidPayment(payload));
  };

  const handlecancel = () => {
    paidForm.resetFields();
    toPayForm.resetFields();
    setIsPaymentModalVisible(false);
    setPaidModalVisible(false);
  };

  const displayToValueMap = [
    { display: 80, value: 20 },
    { display: 81, value: 19 },
    { display: 82, value: 18 },
    { display: 83, value: 17 },
    { display: 84, value: 16 },
    { display: 85, value: 15 },
    { display: 86, value: 14 },
    { display: 87, value: 13 },
    { display: 88, value: 12 },
  ];

  return (
    <Layout
      style={{ backgroundColor: "whitesmoke", height: "calc(100vh - 100px)" }}
    >
      <Flex style={{ flexDirection: "column", rowGap: "20px" }}>
        <Flex style={{ width: "100%" }}>
          <Flex style={{ width: "50%", justifyContent: "start" }}>
            <Title
              level={3}
              style={{
                fontSize: "35px",
                fontWeight: "bolder",
                color: "black",
                fontFamily: "serif",
                textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
                margin: 0,
              }}
            >
              Vehicle Accounts
            </Title>
          </Flex>
          <Flex style={{ width: "50%", justifyContent: "end" }}>
            <Typography.Text
              strong
              style={{
                width: "30%",
                fontSize: "20px",
                padding: "7px",
                backgroundColor: "transparent",
                borderRadius: "12px",
                textAlign: "center",
              }}
            >
              Cabs : {tablelength || 0}
            </Typography.Text>
          </Flex>
        </Flex>
        <Flex style={{ flexDirection: "row", width: "100%" }}>
          <Flex style={{ width: "70%", gap: "2%" }}>
            <DatePicker
              value={fromDate}
              format="DD/MM/YYYY"
              onChange={(date) => setFromDate(date)}
              style={{ border: "1px solid grey", height: "30px" }}
              placeholder="From Date"
              disabledDate={disabledPrevWeeksOnly}
            />
            <DatePicker
              value={toDate}
              format="DD/MM/YYYY"
              onChange={(date) => setToDate(date)}
              style={{ border: "1px solid grey", height: "30px" }}
              placeholder="To Date"
              disabledDate={(current) => {
                if (!current) return false;

                const startOfCurrentCustomWeek = dayjs()
                  .startOf("week")
                  .add(2, "day");
                if (current.isSameOrAfter(startOfCurrentCustomWeek, "day")) {
                  return true;
                }
                if (fromDate && current.isBefore(fromDate, "day")) {
                  return true;
                }

                return false;
              }}
            />

            <Col>
              <Button
                style={{
                  color: "white",
                  background: "#800080",
                  fontWeight: 500,
                }}
                onClick={handleFetch}
              >
                Go
              </Button>
            </Col>
            <Typography.Text
              strong
              style={{
                width: "30%",
                fontSize: "20px",
                padding: "7px",
                backgroundColor: "transparent",
                borderRadius: "12px",
                textAlign: "center",
              }}
            >
              Total Trips : {TotalTrips || 0}
            </Typography.Text>
            <Typography.Text
              strong
              style={{
                width: "30%",
                fontSize: "20px",
                padding: "7px",
                backgroundColor: "transparent",
                borderRadius: "12px",
                textAlign: "center",
              }}
            >
              Turnover : {TotalFare || 0}
            </Typography.Text>
          </Flex>
          <Flex style={{ width: "30%", justifyContent: "end", gap: "2%" }}>
            <CSVLink
              data={csvData}
              headers={headers}
              filename="vehicle_accounts.csv"
            >
              <Button
                icon={<DownloadOutlined />}
                style={{
                  background: "linear-gradient(45deg, #159957, #155799)",
                  color: "white",
                }}
              >
                Download
              </Button>
            </CSVLink>
            <Input
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              prefix={<SearchOutlined />}
              style={{ width: "50%", height: "30px" }}
            />
          </Flex>
        </Flex>
        {(TotalFare > 0 || TotalFare > 0 || tablelength > 0) && (
          <div
            style={{
              padding: "0px",
              float: "left",
              height: "auto",
              width: "100%",
            }}
          >
            <Row justify="center" gutter={[24, 24]} wrap>
              {[
                { label: "Paid", value: TotalPaidAmount },
                { label: "To Pay", value: TotalBalance },
                { label: "Prepaid", value: TotalCreditFare },
                { label: "Pending", value: TotalPending },
                { label: "Overdue", value: TotalOverdue },
                { label: "Surplus", value: TotalSurplus },
              ].map(({ label, value }, idx) => (
                <Col key={idx} xs={24} sm={12} md={8} lg={4} xl={4}>
                  <div
                    style={{
                      padding: "20px",
                      backgroundColor: "#f9fafb",
                      borderRadius: "12px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      textAlign: "center",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(0, 0, 0, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 2px 8px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <div
                      style={{
                        fontSize: "16px",
                        color: "#555",
                        marginBottom: "8px",
                      }}
                    >
                      {label}
                    </div>
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: 600,
                        color: "#222",
                      }}
                    >
                      {value}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}
        <Table
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          dataSource={filteredDataSource}
          onChange={handleTableChange}
          columns={columns}
          rowKey={(record: any) => record.cab_id || record.cabId}
          loading={{
            spinning: loading,
            indicator: <CustomTableLoader />,
          }}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            defaultPageSize: 100,
          }}
          scroll={{ x: "calc(900px + 70%)", y: 50 * 15 }}
          bordered
        />
        <Modal
          style={{ top: "0" }}
          title={
            <div
              style={{
                backgroundColor: "purple",
                color: "white",
                textAlign: "center",
                padding: "10px 0",
                borderRadius: "4px",
                fontSize: "15px",
                fontWeight: "bold",
                marginTop: "20px",
              }}
            >
              {`Add To Pay for - ${selectedCabId}`}
            </div>
          }
          visible={isPaymentModalVisible}
          onCancel={handlecancel}
          footer={null}
          modalRender={(modal) => <div>{modal}</div>}
        >
          <Form
            initialValues={{
              paymentMode: "1",
              paymentDelay: "1",
              subAmount: "0",
              amntRecDate: dayjs(),
            }}
            form={toPayForm}
            onFinish={(values) => handleTopayFormSubmit(values, "Paid")}
            onValuesChange={(changedValues, allValues) => {
              if (
                changedValues.Category !== undefined ||
                changedValues.subAmount !== undefined ||
                changedValues.adjustToPay !== undefined ||
                changedValues.creditFare !== undefined ||
                changedValues.prevBal !== undefined ||
                changedValues.newVehCharge !== undefined
              ) {
                dispatch(
                  updateTopay({
                    bonusPoints: allValues.Category,
                    cabId: selectedCabId,
                    amount: allValues.amount,
                    prepaid: allValues.creditFare,
                    prevBal: allValues.prevBal,
                    subAmount: allValues.subAmount,
                    adjustToPay: allValues.adjustToPay,
                    newVehCharge: selectednewVehCharge,
                  }),
                );
              }
            }}
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            <Form.Item name="amount" label="Amount">
              <Input
                style={{ fontWeight: "bolder" }}
                placeholder="Enter amount"
                readOnly
              />
            </Form.Item>
            <Form.Item
              name="Category"
              label="Category"
              rules={[
                { required: true, message: "Please select Category option!" },
              ]}
            >
              <Select placeholder="Category">
                {displayToValueMap.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.display}%
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="creditFare" label="Prepaid">
              <Input
                type="number"
                onWheel={(e) => (e.target as HTMLInputElement).blur()}
                placeholder="Enter amount"
                style={{ fontWeight: "bolder" }}
              />
            </Form.Item>

            <Form.Item name="prevBal" label="Prev Balance">
              <Input
                type="number"
                onWheel={(e) => (e.target as HTMLInputElement).blur()}
                placeholder="Enter amount"
                style={{ fontWeight: "bolder" }}
              />
            </Form.Item>
            <Form.Item name="subAmount" label="Sub Amount">
              <Input
                type="number"
                placeholder="Sub Amount"
                style={{ fontWeight: "bolder" }}
                disabled={selectedCab?.paidStatus === "Pending"}
                onWheel={(e) => (e.target as HTMLInputElement).blur()}
              />
            </Form.Item>
            <Form.Item name="adjustToPay" label="Add Amount">
              <Input
                type="number"
                onWheel={(e) => (e.target as HTMLInputElement).blur()}
                placeholder="Add"
                style={{ fontWeight: "bolder" }}
              />
            </Form.Item>

            <Form.Item name="topay" label="To Pay">
              <Input
                type="number"
                onWheel={(e) => (e.target as HTMLInputElement).blur()}
                placeholder="Enter amount"
                readOnly
                style={{ fontWeight: "bolder" }}
              />
            </Form.Item>

            <Form.Item wrapperCol={{ span: 24 }}>
              <div
                style={{
                  textAlign: "center",
                  marginTop: 16,
                  display: "flex",
                  justifyContent: "center",
                  gap: "4%",
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ backgroundColor: "green" }}
                >
                  submit
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          style={{ top: "0" }}
          title={
            <div
              style={{
                backgroundColor: "purple",
                color: "white",
                textAlign: "center",
                padding: "10px 0",
                borderRadius: "4px",
                fontSize: "15px",
                fontWeight: "bold",
                marginTop: "20px",
              }}
            >
              {`Add Amount for - ${selectedCabId}`}
            </div>
          }
          visible={isPaidModalVisible}
          onCancel={handlecancel}
          footer={null}
          modalRender={(modal) => <div>{modal}</div>}
        >
          <Form
            initialValues={{
              paymentMode: "1",
              paymentDelay: "false",
              amntRecDate: dayjs(),
            }}
            form={paidForm}
            onFinish={(values) => handlePaidFormSubmit(values, "Paid")}
            onValuesChange={(changedValues, allValues) => {
              const paid = parseFloat(allValues.paid || 0);
              const toPay = parseFloat(allValues.topay || 0);
              const paidAmount = parseFloat(allValues.paidAmount || 0);

              const balance = Math.round(toPay - paid);
              // const balance = Math.round(toPay - paid - paidAmount);

              const formatNumber = (num: any) =>
                Number.isInteger(num) ? num.toString() : num.toFixed(2);

              paidForm.setFieldsValue({
                topay: formatNumber(toPay),
                Balance: formatNumber(balance),
              });
            }}
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            <Form.Item name="topay" label="To Pay">
              <Input
                type="number"
                onWheel={(e) => (e.target as HTMLInputElement).blur()}
                placeholder="Enter amount"
                readOnly
                style={{ fontWeight: "bolder" }}
              />
            </Form.Item>

            <Form.Item
              name="paid"
              label="Paid"
              rules={[
                {
                  required: true,
                  message: "Please Enter Paid Amount!",
                },
              ]}
            >
              <Input
                type="number"
                onWheel={(e) => (e.target as HTMLInputElement).blur()}
                placeholder="Enter amount"
                style={{ fontWeight: "bolder" }}
              />
            </Form.Item>
            {selectedCab?.paidStatus === "Pending" && (
              <Form.Item name="paidAmount" label="Paid Amount">
                <Input
                  type="number"
                  onWheel={(e) => (e.target as HTMLInputElement).blur()}
                  placeholder="Enter amount"
                  readOnly
                  style={{ fontWeight: "bolder" }}
                />
              </Form.Item>
            )}
            <Form.Item
              name="referenceNo"
              label="Reference No"
              rules={[
                {
                  required: true,
                  message: "Please Enter Reference number!",
                },
              ]}
            >
              <Input
                placeholder="Enter Reference number"
                style={{ fontWeight: "bolder" }}
              />
            </Form.Item>
            <Form.Item
              name="amntRecDate"
              label="Amt Received Date"
              rules={[
                {
                  required: true,
                  message: "Please select the amount received date!",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%", fontWeight: "bolder" }}
                format="DD/MM/YYYY"
                disabledDate={(current) => current && current.isAfter(dayjs())}
              />
            </Form.Item>
            <Form.Item name="paymentMode" label="Mode of Payment">
              <Select
                placeholder="Select payment Mode"
                optionLabelProp="children"
              >
                <Option value="1">
                  <span style={{ fontWeight: "bolder" }}>Online</span>
                </Option>
                <Option value="2">
                  <span style={{ fontWeight: "bolder" }}>Cash</span>
                </Option>
                <Option value="3">
                  <span style={{ fontWeight: "bolder" }}>Credit</span>
                </Option>
              </Select>
            </Form.Item>

            <Form.Item name="paymentDelay" label="Payment Status">
              <Select placeholder="Select payment delay">
                <Option value="false" style={{ fontWeight: "bolder" }}>
                  <span style={{ fontWeight: "bolder" }}>On Time</span>
                </Option>
                <Option value="true" style={{ fontWeight: "bolder" }}>
                  <span style={{ fontWeight: "bolder" }}>Delay</span>
                </Option>
              </Select>
            </Form.Item>
            <Form.Item name="Balance" label="Balance">
              <Input
                type="number"
                onWheel={(e) => (e.target as HTMLInputElement).blur()}
                placeholder="Enter amount"
                readOnly
                style={{ fontWeight: "bolder" }}
              />
            </Form.Item>
            <Form.Item name="remark" label="Remark">
              <Input
                placeholder="Enter Remark"
                style={{ fontWeight: "bolder" }}
              />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 24 }}>
              <div
                style={{
                  textAlign: "center",
                  marginTop: 16,
                  display: "flex",
                  justifyContent: "center",
                  gap: "4%",
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ backgroundColor: "green" }}
                >
                  Paid
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Modal>
      </Flex>
    </Layout>
  );
};
export default VehicleAccount;
